export const menuItems = [
  { name: 'What We Do', swipeList: 'What We Do', href: 'wedo' },
  { name: 'Our Story', swipeList: 'Our Story', href: '#about' },
  { name: 'Portfolio', swipeList: 'Portfolio', href: '#services' },
  { name: 'Join Us', swipeList: 'Join Us', href: '#contact' },
  { name: 'Contact Us', swipeList: 'Contact Us', href: '#contact' },
];
